<template>
    <v-app>
        <Navbar />
        <v-content>
            <loading />
            <router-view />
        </v-content>
        <Footnav />
    </v-app>
</template>

<script>
import Navbar from "./components/layout/navbar";
import store from "./store";
import loading from "./components/layout/loading";
import Footnav from "./components/layout/footnav";
export default {
    name: "App",
    /*created: function() {
        this.store.state.user = {
            id: null,
            name: "",
            email: "",
            password: "",
            type: ""
        };
    },*/
    components: {
        Navbar,
        Footnav,
        loading
    },

    data: () => ({
        store: store
    })
};
</script>
<style>
.inputField {
    color: black !important;
}
</style>
